export default {
  props: ['period'],
  data() {
    return {
      saleId: null,
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    loading() { return this.$store.state.loading; },
    sales() { return this.$store.state.sales.sales; },
    isManager() { return this.$store.getters.isManager; },
    isDealer() { return this.$store.getters.isDealer; },
    isApproved() { return !!(this.$store.getters.isApproved); },
    periodId() { return this.$props.period !== 'null' ? decodeURIComponent(this.$props.period) : null; },
    periodLabel() {
      return this.periodId
        ? `. ${this.user.bonuses_extended.find(b => b.id === this.periodId).label}`
        : '';
    },
    surveys() { return this.$store.state.surveys.surveysCompleted || []; },
    tests() { return this.$store.state.courses.testBonusesList.filter(t => t.bonuses) || []; },
    tasks() { return this.$store.state.game.gamesList || []; },
    tasksList() { return this.$store.state.game.taskList || []; },
  },
  methods: {
    GetUnit({ product }) {
      return (product.unit && product.unit.short_name)
        ? product.unit.short_name
        : 'ед';
    },
    OpenDialog(id) {
      this.saleId = id;
      this.dialog = true;
    },
    CloseDialog() {
      this.saleId = null;
      this.dialog = false;
    },
    GetDate(dt) {
      const [year, month, day] = dt.split(' ')[0].split('-');
      return `${day}.${month}.${year}`;
    },
    GetList() {
      this.$store.dispatch('sales/GetSalesList', {
        profile_id: this.user.profile_id,
        period_id: this.periodId,
      });
      this.$store.dispatch('courses/GetTestBonusesList', {
        profile_id: this.user.profile_id,
        period_id: this.periodId,
      });
      this.$store.dispatch('surveys/GetSurveysList', {
        profile_id: this.user.profile_id,
        period_id: this.periodId,
      });
      this.$store.dispatch('game/GetGamesList', {
        profile_id: this.user.profile_id,
        period_id: this.periodId,
      });
      this.$store.dispatch('game/GetTaskList', {
        profile_id: this.user.profile_id,
        period_id: this.periodId,
      });
    },
  },
  mounted() {
    this.GetList();
  },
};
